<template>
  <v-layout row>
    <v-flex xs3 class="pa-3">
        <chartjs-line :data="[40, 60, 45, 70, 90]"
                      :labels="['Явнварь','Февраль','Март','Апрель','Май']"
                      :datalabel="'Производительность'"
                      :pointborderwidth="4"
                      :pointbordercolor="'#f35009'"
                      :pointhoverborderwidth="3"
                      :pointhoverbackgroundcolor="'#636b6f'"
                      :pointhoverbordercolor="'#ffd663'"></chartjs-line>

    </v-flex>

    <v-flex xs3 class="pa-3">
      <canvas id="mycanvas2" count="2"></canvas>
      <chartjs-bar target="mycanvas2" :backgroundcolor="'#383838'" :data="[40, 60, 45, 70, 90]"
                   :labels="['Явнварь','Февраль','Март','Апрель','Май']" :datalabel="'2018 г.'"></chartjs-bar>
      <chartjs-bar target="mycanvas2" :data="[30, 18, 22, 34, 56]"
                   :labels="['Явнварь','Февраль','Март','Апрель','Май']" :datalabel="'2017 г.'"></chartjs-bar>
    </v-flex>

    <v-flex xs3 class="pa-3">
      <chartjs-doughnut :option="{}" :labels="['Коммерческий отдел','Производственный отдел','Административный отдел','Еще какой-то отдел']"></chartjs-doughnut>
    </v-flex>

    <v-flex xs3 class="pa-3">
      <chartjs-pie :option="{}" :backgroundcolor="['#FF6384','#36A2EB','#FFCE56','#03C826']" :labels="['Еще какой-то отдел', 'Административный отдел', 'Коммерческий отдел','Производственный отдел']" :scalesdisplay="false"></chartjs-pie>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    name: 'MyPost',

    data(){
      return {

      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/org/components/MyPost/MyPost.vue